<sl-branding-gate [ready]="companyTheme.ready()" [failed]="companyTheme.failed()" (retry)="companyTheme.retry()" [loadingLabel]="'Cargando…' | slT" [errorLabel]="'No se pudo cargar la configuración de esta empresa.' | slT" [retryLabel]="'Reintentar' | slT">
<router-outlet></router-outlet>
<sl-toast-container></sl-toast-container>

</sl-branding-gate>
